import React from 'react';
import './AvatarBase.less';
import clsx from 'clsx';

interface Props {
  className?: string;
  text: string | React.ReactNode;
  bgColor?: string;
}

export default function AvatarBase({
  className,
  text,
  bgColor = '#1a1a1a',
}: Props) {
  return (
    <span
      className={clsx('avatar-base', className)}
      style={{
        background: bgColor,
        flexShrink: 0,
      }}
    >
      {text}
    </span>
  );
}
